import React from 'react'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

import { Customer } from 'types/DeviceActivity'

import AlertIconWithCount from 'pages/shared/Alert/IconWithCount'
import { phoneNumber } from 'helpers/formatters'

import { color } from 'styles/colors'

export type Props = {
    markerInfo: Required<Customer>
  }

const CustomerMarker = ({ markerInfo } : Props) => {
  return (
    <S.MapInfo>
      {(markerInfo.address1 || markerInfo.address2) && (
        <div>
          {markerInfo.address1 && <span> {markerInfo.address1} </span>}
          {markerInfo.address2 && <span> {markerInfo.address2} </span>}
        </div>
      )}
      {(markerInfo.city || markerInfo.state || markerInfo.zip) && (
        <div>
          {markerInfo.city && <span> {markerInfo.city}, </span>}
          {markerInfo.state && <span> {markerInfo.state} </span>}
          {markerInfo.zip && <span> {markerInfo.zip} </span>}
        </div>
      )}
      {markerInfo.email && (
        <S.Link href={`mailto:${markerInfo.email}`} data-testid="customer-email">{markerInfo.email} </S.Link>
      )}
      {markerInfo.phone && (
        <S.Link href={`tel:${markerInfo.phone}`} data-testid="customer-phone">{phoneNumber(markerInfo.phone)} </S.Link>
      )}
      {
        markerInfo.devices.map(info => (
          (info.criticalAlarmCount !== 0 || info.majorAlarmCount !== 0 || info.sdaMajorAlarmCount !== 0 || info.sdaCriticalAlarmCount !== 0) &&
          <S.Device key={info.deviceId}>
            {
              <>
                <S.Divider />
                <S.DeviceId to={`/customers/${markerInfo.customerId}/systems/${info.deviceId}`} data-testid="device-link">{info.deviceId}</S.DeviceId>
                <S.AlertIconWithCount severity="critical" count={info.criticalAlarmCount} />
                <S.AlertIconWithCount severity="critical-sda" count={info.sdaCriticalAlarmCount} />
                <S.AlertIconWithCount severity="major" count={info.majorAlarmCount} />
                <S.AlertIconWithCount severity="major-sda" count={info.sdaMajorAlarmCount} />
              </>
            }
          </S.Device>
        ))
      }
    </S.MapInfo>
  )
}

export default CustomerMarker

const S = {
  MapInfo: styled.div`
    display: grid;
    overflow: hidden;
  `,
  Link: styled.a`
    margin-top: 10px;
  `,
  DeviceId: styled(NavLink)`
    padding-right: 10px;
  `,
  Device: styled.div`
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  `,
  Divider: styled.div`
    width: 100%;
    border-top: 1px solid ${color('dashboardCardBorder')};
    margin-bottom: 10px;
  `,
  AlertIconWithCount: styled(AlertIconWithCount)`
    display: inline-block;
  `
}
